/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Save_CurrentInputs */

const en_views_save_current = /** @type {(inputs: Views_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save current view`)
};

const de_views_save_current = /** @type {(inputs: Views_Save_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Ansicht speichern`)
};

/**
* | output |
* | --- |
* | "Save current view" |
*
* @param {Views_Save_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_save_current = /** @type {((inputs?: Views_Save_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Save_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_save_current(inputs)
	return en_views_save_current(inputs)
});